import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calculator, History, LogOut, Receipt } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { HistoriqueExports } from '../components/comptabilite/HistoriqueExports';
import { RecusDuMois } from '../components/comptabilite/RecusDuMois';

export default function ExpertComptableDashboard() {
  const { user, getAuthHeader, logout } = useAuth();
  const navigate = useNavigate();
  const [vue, setVue] = useState('exports');
  const tab = (k, label, Icon) => (
    <button type="button" onClick={() => setVue(k)} data-testid={`ec-tab-${k}`}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${vue === k ? 'bg-[#0a3d62] text-white shadow' : 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50'}`}>
      <Icon className="h-4 w-4" /> {label}
    </button>
  );
  return (
    <div className="min-h-screen bg-slate-50" data-testid="expert-comptable-dashboard">
      <header className="bg-[#0a3d62] text-white">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-wrap items-center gap-4">
          <Calculator className="h-8 w-8 text-amber-300" />
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-amber-200">O'SCOP Outremer · Espace expert-comptable</p>
            <h1 className="text-2xl font-bold">Exports & reçus mensuels</h1>
            <p className="text-sm text-slate-200" data-testid="ec-user">{[user?.prenom, user?.nom].filter(Boolean).join(' ')} · {user?.email} · accès en lecture seule</p>
          </div>
          <button type="button" onClick={() => { logout(); navigate('/login'); }} data-testid="ec-logout-btn"
            className="ml-auto inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg border border-white/30 hover:bg-white/10"><LogOut className="h-4 w-4" /> Déconnexion</button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8 space-y-4">
        <div className="flex gap-2">{tab('exports', 'Exports mensuels', History)}{tab('recus', 'Reçus & justificatifs', Receipt)}</div>
        {vue === 'exports' ? <HistoriqueExports headers={getAuthHeader()} /> : <RecusDuMois headers={getAuthHeader()} />}
      </main>
    </div>
  );
}
